/**
 * Date utilities for business-day calculations (excluding Saturday and Sunday).
 * Used for accept deadlines, delivery deadlines, revision deadlines, and review windows.
 */

/** Creator's window to resubmit after the brand requests a revision. */
export const REVISION_DEADLINE_BUSINESS_DAYS = 5;

/** Payment release window after brand approval (working days, Mon–Fri). */
export const PAYMENT_WINDOW_BUSINESS_DAYS = 14;

/**
 * Add N business days to a date (Saturday and Sunday are skipped).
 * @param {Date|string|number} startDate - Start date
 * @param {number} numDays - Number of business days to add
 * @returns {Date} New date at same time of day, numDays business days later
 */
export function addBusinessDays(startDate, numDays) {
  const d = new Date(startDate);
  let added = 0;
  while (added < numDays) {
    d.setDate(d.getDate() + 1);
    const day = d.getDay(); // 0 = Sunday, 6 = Saturday
    if (day !== 0 && day !== 6) added++;
  }
  return d;
}
